import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { resolveImg } from "@/lib/apiData";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
};

export const SeoManager = () => {
  const { config } = useSite();
  const { pathname } = useLocation();
  useEffect(() => {
    const seo = config?.seo;
    if (!seo) return;
    const page = (seo.pages || []).find((p) => p.path === pathname);
    const title = page?.title || seo.meta_title;
    const desc = page?.description || seo.meta_description;
    document.title = title;
    setMeta("name", "description", desc);
    setMeta("name", "keywords", seo.keywords);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:image", resolveImg(seo.og_image));
  }, [config, pathname]);
  return null;
};
